import React from 'react';
export function Footer() {
  return <footer className="w-full bg-white px-5 py-12" data-id="element-85" data-mp="32wd0e9mw79qd">
      <div className="mx-auto max-w-5xl text-center" data-id="element-86" data-mp="3gezev8fo7z39">
        <p className="text-xl font-black uppercase tracking-tight text-stone-900" data-id="element-87" data-mp="3ggk6oqalp3xf">
          Restaurant English Ready
        </p>
        <p className="mx-auto mt-4 max-w-2xl text-[11px] leading-relaxed text-stone-500" data-id="element-88" data-mp="36pfu1x8edv5r">
          English language-practice materials for adult learners. Not a
          certification, food safety training or employment programme.
        </p>
        <p className="mx-auto mt-3 max-w-2xl text-[11px] leading-relaxed text-stone-500" data-id="element-89" data-mp="37fsp0xcko14">
          © 2026 Restaurant English Ready. All rights reserved.
        </p>
      </div>
    </footer>;
}